import { Categories, POPULAR_CATEGORY_ID } from '@/data/categories';

export const calculateAverageRating = (comments) => {
    if (!comments?.length) return 0;
    const totalStars = comments.reduce(
        (acc, comment) => acc + Number(comment.stars_given || 0),
        0
    );
    return totalStars / comments.length;
};

export const hasProductRating = (product) =>
    Boolean(product?.comments?.length) && calculateAverageRating(product.comments) > 0;

export const categoryHasProducts = (categoryId, products) => {
    if (!products?.length) return false;

    if (categoryId === POPULAR_CATEGORY_ID) {
        return products.some(hasProductRating);
    }

    return products.some((p) => p.category === categoryId);
};

/** Categories visible on the client catalog (only those with at least one product). */
export const getVisibleClientCategories = (products) =>
    Categories.filter((cat) => categoryHasProducts(cat.id, products));

export const filterProductsForCategory = (products, activeCategory, searchTerm = '') => {
    let result = [...(products || [])];

    const term = (searchTerm || '').trim().toLowerCase();
    if (term) {
        const keywords = term.split(/\s+/).filter(Boolean);
        return result.filter((p) => {
            const productName = (p.name || '').toLowerCase();
            const productDesc = (p.description || '').toLowerCase();
            return keywords.every(kw => productName.includes(kw) || productDesc.includes(kw));
        });
    }

    if (activeCategory === POPULAR_CATEGORY_ID) {
        return result
            .filter(hasProductRating)
            .sort(
                (a, b) =>
                    calculateAverageRating(b.comments) -
                    calculateAverageRating(a.comments)
            );
    }

    if (activeCategory && activeCategory !== 'all') {
        result = result.filter((p) => p.category === activeCategory);
    }

    return result;
};
